import { Task, TaskStatus } from "../types/taskTypes";

export type LegalProgressPayload = {
  taskId: string;
  processedDocs: number;
  totalDocs: number;
  status: string;
  wipPhase?: string;
  wipJobFormula?: string;
  progressDetail?: string;
};

/**
 * Parse le détail SSE / événement (camelCase ou snake_case).
 */
export function parseLegalSearchProgressPayload(
  raw: Record<string, unknown> | null | undefined
): LegalProgressPayload | null {
  if (!raw) return null;
  const taskId = (raw.taskId ?? raw.task_id) as string | undefined;
  if (!taskId) return null;
  const wfRaw = raw.wipJobFormula ?? raw.wip_job_formula;
  const phaseRaw = raw.wipPhase ?? raw.wip_phase;
  const detailRaw = raw.progressDetail ?? raw.progress_detail;
  const wipJobFormula =
    typeof wfRaw === "string" && wfRaw.trim() ? wfRaw.trim() : undefined;
  const wipPhase =
    typeof phaseRaw === "string" && phaseRaw.trim() ? phaseRaw.trim() : undefined;
  const progressDetail =
    typeof detailRaw === "string" && detailRaw.trim() ? detailRaw.trim() : undefined;
  return {
    taskId,
    processedDocs: Number(raw.processedDocs ?? raw.processed_docs ?? 0),
    totalDocs: Number(raw.totalDocs ?? raw.total_docs ?? 1),
    status: String(raw.status ?? "running"),
    ...(wipPhase ? { wipPhase } : {}),
    ...(wipJobFormula ? { wipJobFormula } : {}),
    ...(progressDetail ? { progressDetail } : {}),
  };
}

/**
 * Applique une progression à une tâche (ne vérifie pas l'id — l’appelant filtre).
 */
export function mergeLegalProgressIntoTask(
  task: Task,
  p: LegalProgressPayload,
  nowMs: number
): Task {
  const isFinalSynthesis =
    p.status === "synthesizing_table" || p.status === "synthesizing_synthesis";
  const nextStatus =
    p.status === "completed"
      ? TaskStatus.COMPLETED
      : p.status === "cancel_requested" ||
          p.status === "cancelled" ||
          p.status === "canceled"
        ? TaskStatus.CANCELLED
      : p.status === "error"
        ? TaskStatus.ERROR
        : isFinalSynthesis
          ? TaskStatus.SUMMARIZING
          : TaskStatus.PROCESSING;
  const fileStatus =
    isFinalSynthesis
      ? "summarizing"
      : p.status === "completed"
        ? "summary_done"
        : p.status === "cancel_requested" ||
            p.status === "cancelled" ||
            p.status === "canceled"
          ? "cancelled"
        : task.file.status;
  return {
    ...task,
    updatedAt: nowMs,
    status: nextStatus,
    legalWipJobFormula: p.wipJobFormula ?? task.legalWipJobFormula,
    legalProgressDetail: p.progressDetail ?? task.legalProgressDetail,
    legalWipPhase: p.wipPhase ?? task.legalWipPhase,
    file: {
      ...task.file,
      nbPages: Math.max(1, p.totalDocs),
      nbProcessed: p.processedDocs,
      nbProcessedSummary: 0,
      status: fileStatus,
    },
  };
}
